<template>

    <div class="nau-form-view">

        <DynamicForm :form="form"/>

    </div>

</template>

<script>


    import DynamicForm from './DynamicForm'

    export default {

       name: 'FormView',

       props: {
              form: {
                  type: Object,
                  required: true
              }
          },


       components: { DynamicForm }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/FormView.vue